export class FetchTree {
  static readonly type = '[Help] Fetch';

  constructor() {
  }
}


export class GetPage {

  static readonly type = '[Help] Get';

  constructor(public id: number) {
  }
}


export class SearchPage {

  static readonly type = '[Help] Search';

  constructor(public text: string) {
  }
}

